import alert from '../../assets/images/icons/alert.svg'
import notFound from '../../assets/images/icons/404.svg'
import bid from '../../assets/images/icons/bid.svg'
import chevron from '../../assets/images/icons/chevron.svg'
import cross from '../../assets/images/icons/cross.svg'
import crossClear from '../../assets/images/icons/cross-clear.svg'
import circleCross from '../../assets/images/icons/circle-cross.svg'
import diamond from '../../assets/images/icons/diamond.svg'
import edit from '../../assets/images/icons/edit.svg'
import fileIndicator from '../../assets/images/icons/file-indicator.svg'
import info from '../../assets/images/icons/info.svg'
import infoLarge from '../../assets/images/icons/info-large.svg'
import loading from '../../assets/images/icons/loading.svg'
import minus from '../../assets/images/icons/minus.svg'
import paperclip from '../../assets/images/icons/paperclip.svg'
import pdfIndicator from '../../assets/images/icons/pdf-indicator.svg'
import plus from '../../assets/images/icons/plus.svg'
import search from '../../assets/images/icons/search.svg'
import tick from '../../assets/images/icons/tick.svg'
import tickBig from '../../assets/images/icons/tick-big.svg'
import user from '../../assets/images/icons/user.svg'
import verified from '../../assets/images/icons/verified.svg'
import logo from '../../assets/images/logo/christies.svg'
import logoChinese from '../../assets/images/logo/christies-chinese.svg'
import home from '../../assets/images/icons/home.svg'
import idCard from '../../assets/images/icons/id-card.svg'
import lock from '../../assets/images/icons/lock.svg'
import gallery from '../../assets/images/icons/gallery.svg'
import calendar from '../../assets/images/icons/calendar.svg'
import eyeOpen from '../../assets/images/icons/eye-open.svg'
import eyeClose from '../../assets/images/icons/eye-close.svg'
import christies from '../../assets/images/icons/christies.svg'
import tickCircle from '../../assets/images/icons/tick-circle.svg'
import infoLight from '../../assets/images/icons/info-light.svg'
import camera from '../../assets/images/icons/camera.svg'
import alertCross from '../../assets/images/icons/alert-cross.svg'

const icons = {
  alert,
  notFound,
  bid,
  chevron,
  cross,
  crossClear,
  circleCross,
  diamond,
  edit,
  fileIndicator,
  info,
  infoLarge,
  loading,
  minus,
  paperclip,
  pdfIndicator,
  plus,
  search,
  tick,
  tickBig,
  user,
  verified,
  logo,
  logoChinese,
  home,
  idCard,
  lock,
  gallery,
  calendar,
  eyeOpen,
  eyeClose,
  christies,
  tickCircle,
  infoLight,
  camera,
  alertCross,
}

export type Icons = keyof typeof icons

export default icons
